import { render, staticRenderFns } from "./NavigationMaster.vue?vue&type=template&id=bc502530&scoped=true"
import script from "./NavigationMaster.vue?vue&type=script&lang=js"
export * from "./NavigationMaster.vue?vue&type=script&lang=js"
import style0 from "./NavigationMaster.vue?vue&type=style&index=0&id=bc502530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc502530",
  null
  
)

export default component.exports